module.exports = __webpack_public_path__ + "img/progress1_icon.7f37ed42.png";